import { BaseModel } from '../../../../core/_base/crud';

export class InterventionHistory extends BaseModel {
  id: number;
  level;
  team_responsible;
  intervention_note;
  start_date;
  completed_date;
  acceptance;
  outcome;
}
